import React, { useState  } from 'react'
import './Login.css'
import { Link,useHistory } from 'react-router-dom'
import {auth} from './firebase'

const Login = () => {
    const history = useHistory();
    const [email,setEmail]=useState('');
    const [password,setPassword]=useState('');

    //--------------Login user ------------------//
    const login = (e) =>{
        e.preventDefault();

        auth.signInWithEmailAndPassword(email,password)
        .then((auth)=>{
            //logged in , redirect to home page
            history.push("/");
        })
        .catch(e=> alert(e.message))
    }
//---------------------register user-----------------------///
    const register = (e) =>{
        e.preventDefault();
        //do the register logic

        auth.createUserWithEmailAndPassword(email,password)
        .then(auth =>{
            //create a user and logged in  && redirect to home page
            if(auth){
                history.push("/")
            }

        })
        .catch((e)=> alert(e.message));


    }

    return (
        <div className='login'>
              <Link to='/'>
                 <img className='login_logo' src="https://beechholdings.co.uk/wp-content/uploads/2020/01/amazon-logo-png-transparent-5.png" alt="" />
            </Link>

            <div className="login_container">
                <h1>Sign In</h1>

                <form>

                    <h5>Email :</h5>
                    <input value={email} onChange={(e)=> setEmail(e.target.value)} placeholder='Enter Your Email' type="email" />
                    <h5>Password :</h5>
                    <input value={password} onChange={(e)=>setPassword(e.target.value)} placeholder='Enter Your Password' type="password" />
                    <button onClick={login} type='submit' className='login_signIn_button'>Sign In</button>

                </form>

                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima magnam earum ipsum suscipit quo.  quidem at optio.</p>

                <button onClick={register} className='login_register_button'>Create Your Amazon Account</button>
            </div>
        </div>
    )
}

export default Login
